var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRing = function SvgRing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1200,
    height: 702,
    fill: "none",
    viewBox: "0 0 1200 702"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M600 2322c640.65 0 1160-519.35 1160-1160S1240.65 2 600 2-560 521.35-560 1162-40.65 2322 600 2322m0 2c641.75 0 1162-520.25 1162-1162C1762 520.245 1241.75 0 600 0-41.755 0-562 520.245-562 1162c0 641.75 520.245 1162 1162 1162",
    clipRule: "evenodd"
  })));
};
export default SvgRing;